export const formatPriceToDolar = (price: number) => {
    if (price === 0)
        return 0;

    return new Intl.NumberFormat("en-US", {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: Math.round(price) === 0 ? 8 : 2
    }).format(price);
};